// extracted by mini-css-extract-plugin
export var embeddedCta = "style-module--embedded-cta--623af";
export var firstSection = "style-module--first-section--11a64";
export var hyperlink = "style-module--hyperlink--d1812";
export var table = "style-module--table--2907c";